import { routes as administracao } from './administracao';
export default [
  {
    path: '/suporte',
    name: 'Suporte',
    description: 'Suporte',
    icon: 'uil-map-marker-question',
    children: [...administracao]
  }
];
